module.exports = __webpack_public_path__ + "static/media/microphone-off.48d154c5.svg";